import { FC, lazy } from 'react';

import LazyComponent from '@editor/components/LazyComponent/LazyComponent';

const LazyPaymentBlockedGraphic = lazy(async () => ({
  default: (await import('./paymentBlocked.svg')).ReactComponent,
}));

const PaymentBlockedGraphic: FC = () => (
  <LazyComponent>
    <LazyPaymentBlockedGraphic />
  </LazyComponent>
);

export default PaymentBlockedGraphic;
